import fetchApi from "../fetchApi";
import useAuth from "../../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";

const useQueryUser = (options?: any) => {
  const { token } = useAuth();
  return useQuery({
    queryKey: ["Users"],
    queryFn: () => fetchApi("users", token).get(),
    staleTime: 10000 * 60 * 10,
    refetchOnWindowFocus: false,
  });
};

export default useQueryUser;
